import Alerts from 'lib/alerts';
import BaseRouter from './Base.js';
import LayoutView from '../views/dashboard/Layout.js';
import Log from 'lib/log';
import isMobile from 'helpers/isMobile';
import ActionLogs from 'newCollections/action-logs.js';
const log = Log('employer/dashboard-router');

module.exports = BaseRouter.extend({
    routes: {
        'dashboard': 'dashboard'
    },

    titles: {
        'dashboard': 'Dashboard'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {log: log});
        BaseRouter.prototype.initialize.apply(this, [this.options]);
    },

    dashboard: function() {
        if (!isMobile.isWorkingWidth()) {
            return this.navigate('errorMobile', {trigger: true});
        }

        this.layout = new LayoutView({
            el: this.el
        });

        const options = {
            /* To identify the object later */
            _isOptions:          true,

            isSetupCompany:      false,
            isAddEmployee:       false,
            isPayrollSaved:      false,
            isPayrollProcessing: false,
            /* TODO Naming of isPayrollDue and isPayrollDueReminder is
             * confusing */
            isPayrollDue:         false,
            isPayrollDueReminder: false,
            isPayrollToBeFinished: false,
            payrollDueText:       ''
        };

        /* On my last commit here I just flattened this callback hell we had.
         * This can be further improved, the method is way too long.
         * */
        new ActionLogs().fetchForCompany(app.company)
            .then(collection => collection.models)
            .then(actionLogs => {
                options.actionLogs = actionLogs;
                options.actionLogsFetchMore = options => {
                    return new ActionLogs().fetchForCompany(
                        app.company, options
                    ).then(collection => collection.models);
                };
                if (!app.company.isBasicInfoSetUp()) {
                    return Promise.reject(
                        Object.assign(options, {isSetupCompany: true})
                    );
                }

                return Promise.resolve(
                    (app.company.get('employeeCount') || 0) > 0
                );
            })
            .then(hasEmployees => {
                if (!hasEmployees) {
                    return Promise.reject(
                        Object.assign(options, {isAddEmployee: true})
                    );
                }

                // TODO
                return false;
                /* return new Payrolls(null, {company: app.company})
                    .fetch({filter: {where: {submittedDate: null}}})
                    .then(r => r.collection.at(0)); */
            })
            .then(unsubmittedPayroll => {
                if (unsubmittedPayroll) {
                    return Promise.reject(
                        Object.assign(options, {isPayrollSaved: true})
                    );
                }

                // TODO
                /* return (new Parse.Query('Payroll'))
                    .equalTo('companyId', app.company.id)
                    .greaterThanOrEqualTo('status', 3)
                    .lessThan('status', 9)
                    .first(); */
                return false;
            })
            .then(processingPayroll => {
                if (processingPayroll && app.company.get('mppAdminId')) {
                    return Promise.reject(
                        Object.assign(options, {isPayrollToBeFinished: true})
                    );
                } else if (processingPayroll) {
                    return Promise.reject(
                        Object.assign(options, {isPayrollProcessing: true})
                    );
                }

                this.layout.renderContent(options);
            })
            .catch(errOrOptions => {
                if (errOrOptions._isOptions === true) {
                    this.layout.renderContent(errOrOptions);
                    return;
                }

                log.error(errOrOptions);
                Alerts.show('criticalError', errOrOptions);
            })
            .finally(() => this.layout.hideLoader());
    }
});



// WEBPACK FOOTER //
// ./app/employer/routers/Dashboard.js